import { useState } from 'react';
import { useEffectOnce } from 'usehooks-ts';
import PropTypes from 'prop-types';

export default function Disclaimer({ region }) {
  const [informationMessage, setInformationMessage] = useState(null);
  useEffectOnce(() => {
    import(`./markdown/disclaimer_${region}.md`)
      .then((res) => {
        setInformationMessage(`* ${res.default}`);
      })
      .catch((err) => console.log(err));
  });

  return (
    <>
      <div>{informationMessage}</div>
    </>
  );
}

Disclaimer.propTypes = {
  region: PropTypes.string,
};
